import { render, staticRenderFns } from "./option.vue?vue&type=template&id=0c289ed1&scoped=true&"
import script from "./option.vue?vue&type=script&lang=js&"
export * from "./option.vue?vue&type=script&lang=js&"
import style0 from "./option.vue?vue&type=style&index=0&id=0c289ed1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c289ed1",
  null
  
)

export default component.exports